import { render, staticRenderFns } from "./get-to-know-you.vue?vue&type=template&id=f8c736c6&scoped=true"
import script from "./get-to-know-you.vue?vue&type=script&lang=js"
export * from "./get-to-know-you.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c736c6",
  null
  
)

export default component.exports